import {
  Directive,
  HostListener,
  Input
} from '@angular/core';
import { GtagService } from './gtag.service';

@Directive({
  selector: '[appGtagEvent]'
})

export class GtagEventDirective {
  @Input('eventCategory') eventCategory: string = null;
  @Input('eventAction') eventAction: string = null;
  @Input('eventLabel') eventLabel: string = null;
  @Input('eventValue') eventValue: string = null;

  constructor(
    private gtagService: GtagService
  ) { }

  @HostListener('click')
  onClick(): void {
    this.validateInputs();
    this.gtagService.sendEvent(this.eventCategory, this.eventAction, this.eventLabel, this.eventValue);
  }

  validateInputs(): void {
    if (!this.eventCategory) {
      throw new Error('GtagEventDirective: eventCategory is not defined');
    }

    if (!this.eventAction) {
      throw new Error('GtagEventDirective: eventAction is not defined');
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/common-theme/analytics/gtag-event.directive.ts